import { render, staticRenderFns } from "./index.vue?vue&type=template&id=961c4e72&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./index.vue?vue&type=style&index=1&id=961c4e72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961c4e72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('961c4e72')) {
      api.createRecord('961c4e72', component.options)
    } else {
      api.reload('961c4e72', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=961c4e72&scoped=true", function () {
      api.rerender('961c4e72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/marketingEvents/index.vue"
export default component.exports